import { TableHeader, TableRow } from '@/common';

export enum HazardView {
  Both = '32Co1OA4ZcUbSVNdEBvxW',
  Map = '5HU9JSu76vCrG6hcmyqkL',
  List = 'ZA7a13bj-hgRb--l3lLce',
}

export enum MapMode {
  Default = 'Default',
}

export interface HazardTable {
  label: string;
  headers: TableHeader[];
  rows: TableRow[];
}
